<div class="container py-4" >
    <div class="d-flex justify-content-between">
      <!-- <h4
        class="m-0 fw-500 mb-4"
        translate="security_dashboard.dash.contracts"></h4>
      <button (click)="additionalData()" class="btn btn-primary mb-4"
        translate="security_dashboard.dash.Additional_clauses_of_the_contract"></button> -->
    </div>
  
    <app-tab-layout [list]="list"></app-tab-layout>
  </div>